module.exports = __webpack_public_path__ + "img/07_3_2_2.da4ac839.png";